/**
 * Servicio: etiquetas
 * Endpoint: /wsetiqueta
 */

import { sendRequest } from '../../config';

export interface getEtiquetasParams {
    /** parametros obligatorios */
    cpais: string; //codigo del pais

    /** parametros opcionales */
    //aqui se pueden ir agregando los campos que van requeriendo para consultar
    cetiqueta?: string;
    xdescripcion?: string;
    iestado?: string;
}

export interface datagetEtiquetas {
    cetiqueta?: string;
    u_version?: string;
    xdescripcion?: string;
    iestado?: string;
    fingreso?: string;
    bloqueado?: string;
    cerrado?: string;
    cusuario?: string;
    ccategoria?: string;
    cuusuarioauto?: string;
    ccategoriaauto?: string;
    fultmod?: string;
    cusuariomod?: string;
    ccategiriamod?: string;
    description?: string;
}

export const getEtiquetas = async (params: getEtiquetasParams): Promise<datagetEtiquetas[]> => {
    const ENDPOINT = 'wsetiqueta/get';
    return sendRequest({
        method: 'post',
        path: ENDPOINT,
        body: params,
    });
};